import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Wrench, Check, Rocket } from 'lucide-react';
import { HOW_IT_WORKS_STEPS } from '../constants';

const stepIcons = [Phone, Wrench, Check, Rocket];

export const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="bg-white border-b border-slate-100">
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-400/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        {/* Hero Image */}
        <div className="relative rounded-2xl overflow-hidden mb-16">
          <img
            src="/persona-tecnico-setup.jpg"
            alt=""
            className="w-full h-[200px] md:h-[300px] object-cover"
            loading="lazy"
            style={{ objectPosition: '50% 35%' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-white via-white/70 to-white/40" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <span
              className="inline-flex items-center gap-2 py-1 px-4 rounded-full text-sm font-bold mb-4 uppercase tracking-widest"
              style={{
                background: 'rgba(60,179,113,0.1)',
                border: '1px solid rgba(60,179,113,0.25)',
                color: '#2d8653',
              }}
            >
              Proceso
            </span>
            <h2
              className="font-black text-slate-900 mb-2"
              style={{ fontSize: 'clamp(1.8rem, 5vw, 3rem)', letterSpacing: '-0.02em' }}
            >
              Cómo funciona
            </h2>
            <p className="text-slate-700 font-medium text-sm md:text-base max-w-xl">
              De la primera llamada a todo funcionando en menos de una semana
            </p>
          </div>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 relative">
          {/* Connecting line */}
          <div
            className="hidden md:block absolute top-[2.75rem] left-[12.5%] right-[12.5%] h-px"
            style={{
              background: 'linear-gradient(90deg, transparent, rgba(60,179,113,0.3) 20%, rgba(60,179,113,0.3) 80%, transparent)',
              zIndex: 0,
            }}
          />

          {HOW_IT_WORKS_STEPS.map((step, idx) => {
            const Icon = stepIcons[idx];
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="step-card relative bg-white p-6 rounded-2xl text-center transition-all duration-300 cursor-default"
                style={{
                  border: '1px solid rgba(0,0,0,0.07)',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  zIndex: 1,
                }}
              >
                {/* Step number */}
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 text-lg font-black text-white"
                  style={{
                    background: 'linear-gradient(135deg, #1e293b, #334155)',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                  }}
                >
                  {step.number}
                </div>

                {/* Icon */}
                <div className="mb-3 text-slate-400 flex justify-center">
                  <Icon size={22} />
                </div>

                <h4
                  className="font-bold text-base text-slate-900 mb-2"
                  style={{ letterSpacing: '-0.01em' }}
                >
                  {step.title}
                </h4>
                <p className="text-sm text-slate-500 leading-relaxed font-light">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
